import { useMemo } from 'react'
import { EVERYONE_ADDRESS, getChannelSettingsQueryData, useChannelSettings } from 'use-towns-client'

export function useChannelEntitlements({
    spaceId,
    channelId,
    enabled = true,
}: {
    spaceId: string | undefined
    channelId: string | undefined
    enabled?: boolean
}) {
    const { channelSettings, error, isLoading } = useChannelSettings(
        spaceId ?? '',
        channelId ?? '',
        enabled,
    )

    return useMemo(() => {
        return {
            ...transformData(channelSettings),
            error,
            isLoading,
        }
    }, [channelSettings, error, isLoading])
}

function transformData(channelSettings: ReturnType<typeof useChannelSettings>['channelSettings']) {
    const ruleEntitlements = channelSettings?.roles.map((r) => r.ruleData)
    const userEntitlments = channelSettings?.roles.map((r) => r.users)

    const hasRuleEntitlement = ruleEntitlements?.some((r) => {
        return r.rules.checkOperations.length > 0
    })

    const hasUserEntitlement = userEntitlments?.some(
        (u) => u.length > 0 && !u.includes(EVERYONE_ADDRESS),
    )

    const hasEveryoneEntitlement = userEntitlments?.some((u) => u.includes(EVERYONE_ADDRESS))

    return {
        hasSomeEntitlement: !hasEveryoneEntitlement && (hasRuleEntitlement || hasUserEntitlement),
        hasRuleEntitlement,
        hasUserEntitlement,
        hasEveryoneEntitlement,
        channelName: channelSettings?.name,
    }
}

export function getChannelEntitlementsQueryData(args: { spaceId: string; channelId: string }) {
    const queryData = getChannelSettingsQueryData(args)
    return transformData(queryData)
}
